import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
const stages = [{
  num: '01',
  title: 'Despierta',
  desc: 'Despierta a la verdad de quién eres y reconoce que fuiste creado para más que una vida ordinaria.'
}, {
  num: '02',
  title: 'Alinea',
  desc: 'Ordena tu mente, tus hábitos y tu espíritu para caminar en dirección a una vida con intención y significado.'
}, {
  num: '03',
  title: 'Fortalece',
  desc: 'Construye disciplina, carácter y convicción para sostener tu crecimiento y avanzar con excelencia.'
}, {
  num: '04',
  title: 'Expande',
  desc: 'Vive tu propósito con impacto, abundancia y una visión mayor que transforme tu vida y la de otros.'
}];
export function RutaCrece() {
  const {
    ref,
    isVisible
  } = useScrollReveal({
    threshold: 0.1
  });
  return <section id="ruta" className="py-20 md:py-36 bg-[#050505] relative overflow-hidden" data-id="element-172">
      {/* Ambient gold glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[500px] bg-gold/[0.04] rounded-full blur-[140px] pointer-events-none" data-id="element-173" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-174">
        {/* Header */}
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 40
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-16 md:mb-24" data-id="element-175">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-176">
            <div className="w-8 h-[1px] bg-gold" data-id="element-177" />
            <span className="font-montserrat text-gold tracking-[0.3em] text-xs uppercase" data-id="element-178">
              El Camino
            </span>
            <div className="w-8 h-[1px] bg-gold" data-id="element-179" />
          </div>

          <h2 className="font-montserrat font-extrabold text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-[0.08em] md:tracking-[0.12em] mb-8 leading-none" data-id="element-180">
            <span className="text-warmWhite" data-id="element-181">RUTA </span>
            <span className="text-gold" data-id="element-182">CRECE</span>
          </h2>

          <div className="w-16 h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent mx-auto mb-8" data-id="element-183" />

          <p className="font-montserrat text-base md:text-xl text-mutedGray font-light max-w-3xl mx-auto leading-relaxed tracking-wide" data-id="element-184">
            Un camino de transformación para quienes fueron llamados a algo más:
            descubrir su propósito, elevar su vida y vivir con{' '}
            <span className="text-warmWhite italic" data-id="element-185">excelencia</span>.
          </p>
        </motion.div>

        {/* Stages Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" data-id="element-186">
          {stages.map((stage, index) => <motion.article key={stage.num} initial={{
          opacity: 0,
          y: 50
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 1,
          delay: 0.3 + index * 0.12,
          ease: [0.16, 1, 0.3, 1]
        }} className="group relative bg-richBlack/60 border border-white/5 p-8 md:p-10 transition-all duration-700 hover:border-gold/40 hover:bg-richBlack/80 hover:-translate-y-1" data-id="element-187">
              {/* Top accent line that appears on hover */}
              <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" data-id="element-188" />

              {/* Oversized stage number */}
              <div className="font-montserrat font-light text-gold/40 group-hover:text-gold/70 transition-colors duration-700 mb-6 leading-none tracking-tight" style={{
            fontSize: 'clamp(4.5rem, 10vw, 7rem)'
          }} aria-hidden="true" data-id="element-189">
                {stage.num}
              </div>

              {/* Divider */}
              <div className="w-10 h-[1px] bg-gold mb-6 group-hover:w-16 transition-all duration-500" data-id="element-190" />

              {/* Stage name */}
              <h3 className="font-montserrat font-semibold text-gold uppercase tracking-[0.25em] text-xs md:text-sm mb-5" data-id="element-191">
                {stage.title}
              </h3>

              {/* Description */}
              <p className="font-montserrat text-warmWhite/85 text-base md:text-[15px] font-light leading-relaxed" data-id="element-192">
                {stage.desc}
              </p>

              {/* Bottom accent dot */}
              <div className="mt-8 w-1.5 h-1.5 rounded-full bg-gold/30 group-hover:bg-gold transition-colors duration-500" data-id="element-193" />
            </motion.article>)}
        </div>

        {/* Closing line */}
        <motion.div initial={{
        opacity: 0
      }} animate={isVisible ? {
        opacity: 1
      } : {}} transition={{
        duration: 1,
        delay: 0.9
      }} className="mt-16 md:mt-24 text-center" data-id="element-194">
          <div className="w-px h-12 md:h-16 bg-gradient-to-b from-gold/50 to-transparent mx-auto" data-id="element-195" />
        </motion.div>
      </div>
    </section>;
}